var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-end"},[_c('dropdown-menu',{staticClass:"ml-auto",attrs:{"items":_vm.actions,"select":_vm.onActionSelect}},[_c('font-awesome-icon',{attrs:{"icon":"ellipsis-h"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }